"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const AppBaseComponent_1 = require("../../../commons/AppBaseComponent");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const app_service_1 = require("../../../commons/app.service");
const http_1 = require("@angular/common/http");
const core_2 = require("@ngx-translate/core");
const main_service_1 = require("../../main.service");
const map_service_1 = require("../../../commons/map.service");
const map_component_1 = require("../map.component");
const common_1 = require("@angular/common");
const application_events_service_1 = require("../../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
class GuideComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, t, mainService, trans, mapService, httpClient, ar, mapComp, location, applicationEvents) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.t = t;
        this.mainService = mainService;
        this.trans = trans;
        this.mapService = mapService;
        this.httpClient = httpClient;
        this.ar = ar;
        this.mapComp = mapComp;
        this.location = location;
        this.id = null;
        this.guide = null;
        this.layers = null;
        this.mapComp.detailsNav.open();
    }
    init() {
        this.layers = this.mapComp.layerComp;
        console.log('### open details GUIDE');
    }
    ngAfterViewInit() {
        this.loading = false;
        this.ar.params.subscribe(s => {
            if (this.id) {
                this.mapComp.detailsNav.close();
            }
            this.id = s.id;
            if (this.layers && this.layers.currentScene && this.layers.currentScene['cameras']) {
                this.guide = this.layers.currentScene['cameras'].find(c => c.id == this.id);
            }
            if (!this.guide) {
                this.mapComp.detailsNav.close();
                this.router.navigate(["../../"], { relativeTo: this.ar });
            }
            else {
                this.layers.selectedGuide = this.id;
                this.flyTo();
            }
            console.log('@@@@@@@@@@@@@@@@@@', s, this, this.layers.currentScene);
        });
    }
    close() {
        this.mapComp.detailsNav.close();
        this.router.navigate(['../../'], { relativeTo: this.ar });
    }
    save() {
        this.close();
    }
    destroy() {
        this.layers.selectedGuide = null;
        this.close();
    }
    delete() {
        this.layers.deleteCamera(this.guide);
        this.close();
    }
    flyTo() {
        this.layers.flyToCamera(this.guide);
    }
    snapCamera() {
        this.layers.snapCamera(this.guide);
    }
}
exports.GuideComponent = GuideComponent;
